import { goToCoords } from './utils';
import { SELECTORS } from './init';

// Labels
export const setFilter = (cid) => {
	const labelCtr = document.querySelector(SELECTORS.labels);
	const labels = labelCtr.querySelectorAll(SELECTORS.label);
	const active = 'world__location--active';

	labels.forEach((l) => {
		l.classList.remove(active);
	});

	const labelsToActive = labelCtr.querySelectorAll(`${SELECTORS.label}[data-country=${cid.toLowerCase()}]`);
	labelsToActive.forEach((l) => {
		l.classList.add(active);
	});
};

// Button interactions
const buttons = document.querySelectorAll(SELECTORS.btn);

buttons.forEach((b) =>
	b.addEventListener('click', (e) => {
		const target = e.target;
		const btnCtr = target.closest(SELECTORS.btn_ctr);
		const allBtns = btnCtr.querySelectorAll(SELECTORS.btn);
		const active = 'filter__element--active';

		// if (!target.classList.contains(active)) {
		goToCoords(target.dataset.cat);
		setFilter(target.dataset.cat);

		allBtns.forEach((btn) => {
			btn.classList.remove(active);
		});

		target.classList.add(active);
		// }
	}),
);

// Active the first filter on load
if (buttons) {
	document.addEventListener('DOMContentLoaded', () => {
		buttons[0]?.classList.add('filter__element--active');
	});
}
